module.exports = __webpack_public_path__ + "img/3.a9c4c541.png";